/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PriceField, { PriceFieldProps } from './PriceField'

function SecurityDepositField (props: PriceFieldProps) {
  const { name = 'securityDeposit', ...others } = props
  const intl = useIntl()
  return (
    <PriceField
      label={intl.formatMessage({
        id: 'security_deposit',
        defaultMessage: 'Dépôt de garantie'
      })}
      name={name}
      {...others}
    />
  )
}

export default SecurityDepositField
